// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___748d9cb7c7b8c720032","cls2":"AuthorHeader-cls2___a996a503ea543121fd3 AuthorHeader-cls1___748d9cb7c7b8c720032"};